"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M3.7 6.7a2 2 0 0 1 2-2h12.6a2 2 0 0 1 2 2v8.313a2 2 0 0 1-2 2h-5.888a1 1 0 0 0-.705.292l-1.757 1.75a1 1 0 0 1-1.586-.235l-.692-1.282a1 1 0 0 0-.88-.525H5.7a2 2 0 0 1-2-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 7.7A3.7 3.7 0 0 1 6.7 4h10.6A3.7 3.7 0 0 1 21 7.7v6.45a3.7 3.7 0 0 1-3.7 3.7h-4.437c-.368 0-.722.145-.983.405l-1.494 1.48c-1.213 1.202-3.273.343-3.273-1.364a.52.52 0 0 0-.521-.521H6.27A3.27 3.27 0 0 1 3 14.58zm3.7-2.3a2.3 2.3 0 0 0-2.3 2.3v6.88a1.87 1.87 0 0 0 1.87 1.87h.322c1.06 0 1.92.86 1.92 1.921 0 .463.56.696.888.37l1.494-1.48a2.8 2.8 0 0 1 1.97-.811H17.3a2.3 2.3 0 0 0 2.3-2.3V7.7a2.3 2.3 0 0 0-2.3-2.3z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MessageIcon24.js.map